<template>
  <one-tag
    closable
    type="secondary"
    @close="closeTagFilter"
  >
    <span class="b2b-filter-button__value">{{ $t(filter.value) + ': ' }}</span>
    <span class="b2b-filter-button__query">{{ filter.labelText }}</span>
  </one-tag>
</template>

<script>
export default {
  name: 'B2bFilterButtonSalesReport',
  props: {
    filter: {
      required: true,
      type: Object
    }
  },
  methods: {
    closeTagFilter () {
      this.$emit('closeTag', this.filter)
    }
  }
}
</script>

<style scoped>
.b2b-filter-button__value {
  font-weight: bold;
}
.b2b-filter-button__query {
  margin-left: 4px;
}
</style>
